import { HotelsFilters } from '@app/models/filtermodels/HotelsFilters';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import moment from 'moment';

export class ObjFilter {
    protected realparams: ParamFilters = {} as ParamFilters;
    protected filtersData: HotelsFilters;
    protected limit: number = 5;
    protected agenturen: any[] = [];

    constructor(realparams: ParamFilters, limit?: number, agenturen?: any[]) {
        try {
            if (realparams) {
                this.realparams = JSON.parse(JSON.stringify(realparams));
                this.limit = limit;
                this.agenturen = agenturen;
            }
        } catch (error) {
            console.log(error);
        }
    }

    initFilters(from?: string): HotelsFilters {
        this.filtersData = {} as HotelsFilters;
        this.filtersData.productType = this.realparams.productType;
        if (this.filtersData.productType !== 'flight' && this.filtersData.productType !== 'oneway') {
            this.initZiel();
            this.initHotelChainList();
            this.initInclusiveList();
            this.initFacilityList();
            this.initRoomtype();
            this.initRoomIdList();
            this.initServiceCodeList();
            if (from !== 'offers') {
                this.initRating();
                this.initCategory();
            }
            if (from === 'offers') {
                this.filtersData.extra = this.realparams?.extra;
            }
        } else {
            // this.setRegionForFlug();
        }
        this.setOperatorsAndInclists();
        this.initDates();
        if (this.filtersData.productType === 'pauschal' || this.filtersData.productType === 'railtravel' || this.filtersData.productType === 'flight' || this.filtersData.productType === 'oneway') {
            if (this.filtersData.productType !== 'railtravel') {
                this.initFlug();
            }
            this.initAirports();
            this.initTime();
        }
        this.initReisende();

        this.initSortby();
        this.checkTourOperatorList();
        if (from !== 'offers') {
            this.initkeywordList();
        }
        this.initLocatedList();
        this.initboardTypeList();
        this.initPrice();
        this.initNavigate();

        if (this.filtersData.productType === 'oneway') {
            this.filtersData.duration = null;
            this.filtersData.minDuration = null;
            this.filtersData.maxDuration = null;
        }
        return this.filtersData;
    }

    initExtraFilters(): HotelsFilters {
        this.filtersData = {} as HotelsFilters;
        this.filtersData.productType = this.realparams.productType;
        this.filtersData.productSubType = 'all';
        this.initPrice();
        this.initZiel();
        this.initDates()
        this.initTime();
        this.initAirports();
        this.initReisende();
        this.initFacilityList();
        this.initInclusiveList();
        this.initCategory();
        this.initFlug();
        this.checkTourOperatorListforStatic();
        return this.filtersData;
    }

    protected setRegionForFlug() {
        this.filtersData.regionList = this.realparams.regionList;
    }

    protected initNavigate(): void {
        this.filtersData.navigation = '0, ' + this.limit;
    }

    protected initZiel(): void {
        if (this.realparams.pauschalreiseResult?.type === 3) {
            this.filtersData.regionList = this.realparams.pauschalreiseResult.data?.code;
        } else if (this.realparams.pauschalreiseResult?.type === 4) {
            this.filtersData.countryList = this.realparams.pauschalreiseResult.data?.code;
        } else if (this.realparams.pauschalreiseResult?.type === 2) {
            this.filtersData.locationList = this.realparams.pauschalreiseResult.data?.code;
        } else if (this.realparams?.pauschalreiseResult?.data?.code?.length > 0) {
            if (String(this.realparams.pauschalreiseResult.data?.code).includes('_')) {
                const tmp = String(this.realparams.pauschalreiseResult.data?.code).split('_');
                this.filtersData.hotelCodeList = tmp[1];
                // sktv
                if (this.realparams?.bookingcode?.length > 0) {
                    this.filtersData.hotelCodeList = this.realparams?.bookingcode;
                }
                // this.filtersData.hotelName = this.realparams.pauschalreiseResult.data?.name;
            } else {
                this.filtersData.giataIdList = this.realparams.pauschalreiseResult.data?.code;
                // this.filtersData.hotelName = this.realparams.pauschalreiseResult.data?.name;
                this.filtersData.giataIdList = this.filtersData.giataIdList?.length >= 1 ? this.filtersData.giataIdList : '';
            }
        }
        if (!this.realparams.extra) {
            if (this.realparams?.giataIdList?.length > 0) {
                this.filtersData.giataIdList = this.realparams?.giataIdList;
            }
        }
        if (this.realparams?.hotelCodeList?.length > 0) {
            this.filtersData.hotelCodeList = this.realparams?.hotelCodeList;
        }
    }

    protected initFacilityList(): void {
        this.filtersData.facilityList = '';
        if (this.realparams.facilityList?.length > 0) {
            for (let i = 0; i < this.realparams.facilityList.length; i++) {
                this.filtersData.facilityList += (this.filtersData.facilityList?.length > 0 ? ',' : '') + this.realparams.facilityList[i].code;
            }
        }
    }

    protected initDates(): void {
        const reg = new RegExp('^\\d+,\\d+,\\d+$');
        if (String(this.realparams.reisezeitraumResult)?.match(reg)) {
            this.filtersData.searchDate = this.realparams.reisezeitraumResult;
            const tmp_d = this.realparams.reisezeitraumResult.split(',').slice(-1)[0];
            // this.filtersData.duration = ',,' + tmp_d + ',99';
            this.filtersData.minDuration = tmp_d;
            this.filtersData.maxDuration = '17';
        } else {
            if (Number(this.realparams.reiseMonth) >= 0) {
                let year = moment().year();
                let start = '';
                let end = '';
                if (moment().month() > Number(this.realparams.reiseMonth)) {
                    year += 1;
                    start = moment().set({ date: 1, month: Number(this.realparams.reiseMonth), year: year }).format('YYYY-MM-DD');
                    end = moment(start).add(60, 'days').format('YYYY-MM-DD');
                } else if (moment().month() === Number(this.realparams.reiseMonth)) {
                    start = moment().format('YYYY-MM-DD');
                    end = moment(start).add(60, 'days').format('YYYY-MM-DD');
                } else {
                    start = moment().set({ date: 1, month: Number(this.realparams.reiseMonth), year: year }).format('YYYY-MM-DD');
                    end = moment(start).add(60, 'days').format('YYYY-MM-DD');
                }
                this.realparams.reisezeitraumResult.start = start;
                this.realparams.reisezeitraumResult.end = end;
            } else if (this.realparams?.reisezeitraumResult?.start && this.realparams?.reisezeitraumResult?.end) {
                if (!isNaN(Number(this.realparams?.reisezeitraumResult?.start))) {
                    this.realparams.reisezeitraumResult.start = moment().add(Number(this.realparams.reisezeitraumResult.start), 'days').format('YYYY-MM-DD');
                    this.realparams.reisezeitraumResult.end = moment().add(Number(this.realparams.reisezeitraumResult.end), 'days').format('YYYY-MM-DD');
                } else {
                    this.realparams.reisezeitraumResult.start = moment(this.realparams.reisezeitraumResult.start).format('YYYY-MM-DD');
                    this.realparams.reisezeitraumResult.end = moment(this.realparams.reisezeitraumResult.end).format('YYYY-MM-DD');
                }
            } else {
                if (!this.realparams?.reisezeitraumResult?.minDuration) {
                    if (!this.realparams.reisezeitraumResult) {
                        this.realparams.reisezeitraumResult = {
                            start: moment().add(4, 'days').format('YYYY-MM-DD'),
                            end: moment().add(180, 'days').format('YYYY-MM-DD'),
                            minDuration: 7,
                            maxDuration: 17
                        };
                    } else {
                        this.realparams.reisezeitraumResult.minDuration = this.realparams?.reisedauerResult?.value;
                    }
                }
            }
            if (moment(this.realparams?.reisezeitraumResult?.start).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
                if (!isNaN(Number(this.realparams?.reisezeitraumResult?.start))) {
                    this.realparams.reisezeitraumResult.start = moment().add(Number(this.realparams.reisezeitraumResult.start), 'days').format('YYYY-MM-DD');
                } else {
                    this.realparams.reisezeitraumResult.start = moment().format('YYYY-MM-DD');
                }
            }

            if (moment(this.realparams?.reisezeitraumResult?.end).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
                if (!isNaN(Number(this.realparams?.reisezeitraumResult?.end))) {
                    this.realparams.reisezeitraumResult.end = moment().add(Number(this.realparams.reisezeitraumResult.end), 'days').format('YYYY-MM-DD');
                } else {
                    this.realparams.reisezeitraumResult.end = moment(this.realparams.reisezeitraumResult.start)
                        .add(180, 'days').format('YYYY-MM-DD');
                }
            }

            // if (moment(this.realparams?.reisezeitraumResult?.end).format('YYYY-MM-DD') < moment(this.realparams.reisezeitraumResult.start).add(7, 'days').format('YYYY-MM-DD')) {
            //     this.realparams.reisezeitraumResult.end = moment(this.realparams.reisezeitraumResult.start)
            //         .add(7, 'days').format('YYYY-MM-DD');
            // }
            this.filtersData.fromDate = this.realparams?.reisezeitraumResult?.start;
            this.filtersData.toDate = this.realparams?.reisezeitraumResult?.end;
            if (this.realparams?.reisezeitraumResult?.minDuration === '-1') {
                this.filtersData.minDuration = moment.duration(moment(this.realparams?.reisezeitraumResult?.end).diff(this.realparams?.reisezeitraumResult?.start)).asDays().toFixed(0);
                this.filtersData.maxDuration = this.filtersData.minDuration;
                // this.filtersData.duration = ',,' + this.filtersData.minDuration + ',' + this.filtersData.maxDuration;
            } else if (this.realparams?.reisezeitraumResult?.minDuration && Number(this.realparams?.reisezeitraumResult?.minDuration) <= moment.duration(moment(this.realparams?.reisezeitraumResult?.end).diff(this.realparams?.reisezeitraumResult?.start)).asDays()) {
                this.filtersData.minDuration = this.realparams?.reisezeitraumResult?.minDuration;
                this.filtersData.maxDuration = this.realparams?.reisezeitraumResult?.maxDuration ? this.realparams?.reisezeitraumResult?.maxDuration : '30';
                // this.filtersData.duration = ',,' + this.filtersData.minDuration + ',' + this.filtersData.maxDuration;
            } else if (this.realparams?.reisezeitraumResult?.minDuration?.length > 0) {
                this.filtersData.minDuration = moment.duration(moment(this.realparams?.reisezeitraumResult?.end).diff(this.realparams?.reisezeitraumResult?.start)).asDays().toFixed(0);
                this.filtersData.maxDuration = this.realparams?.reisezeitraumResult?.maxDuration ? this.realparams?.reisezeitraumResult?.maxDuration : moment.duration(moment(this.realparams?.reisezeitraumResult?.end).diff(this.realparams?.reisezeitraumResult?.start)).asDays().toFixed(0);
                // this.filtersData.duration = ',,' + this.filtersData.minDuration + ',' + this.filtersData.maxDuration;
            } else {
                if (Number(this.realparams?.reisedauerResult?.minDuration) > 0 && Number(this.realparams?.reisedauerResult?.maxDuration) > 0) {
                    // this.filtersData.duration = ',,' + Number(this.realparams?.reisedauerResult?.minDuration) + ',' +
                    //     Number(this.realparams?.reisedauerResult?.maxDuration);
                    this.filtersData.minDuration = this.realparams?.reisedauerResult?.minDuration;
                    this.filtersData.maxDuration = this.realparams?.reisedauerResult?.maxDuration;
                } else {
                    // this.filtersData.duration = ',,1,99';
                    this.filtersData.minDuration = '3';
                    this.filtersData.maxDuration = '17';
                }
            }
        }
        // if (!this.filtersData.duration || this.filtersData.duration?.length === 0) {
        //     if (Number(this.realparams?.reisedauerResult?.minDuration) > 0 && Number(this.realparams?.reisedauerResult?.maxDuration) > 0) {
        //         this.filtersData.duration = ',,' + Number(this.realparams?.reisedauerResult?.minDuration) + ',' +
        //         Number(this.realparams?.reisedauerResult?.maxDuration);
        //     } else if (Number(this.realparams?.reisedauerResult?.minDuration) > 0) {
        //         this.filtersData.duration = ',,' + Number(this.realparams?.reisedauerResult?.minDuration) + ',99';
        //     } else if (Number(this.realparams?.reisedauerResult?.maxDuration) > 0) {
        //         this.filtersData.duration = ',,1,' + Number(this.realparams?.reisedauerResult?.maxnDuration);
        //     } else {
        //         // this.filtersData.duration = ',,1,99';
        //         this.filtersData.minDuration = '1';
        //         this.filtersData.maxDuration = '30';
        //     }
        // }
        // console.log(this.realparams);
        // console.log(this.filtersData);
    }

    protected initAirports(): void {
        this.filtersData.departureAirportList = '';
        if (this.realparams.airportsResult) {
            if (this.realparams.airportsResult && this.realparams.airportsResult.length > 0) {
                for (let i = 0; i < this.realparams.airportsResult.length; i++) {
                    this.filtersData.departureAirportList += '' + this.realparams.airportsResult[i].code;
                    if (i < this.realparams.airportsResult.length - 1) {
                        this.filtersData.departureAirportList += ',';
                    }
                }
            }
        }

        this.filtersData.arrivalAirportList = '';
        if (this.realparams.arrivalAirportList) {
            if (this.realparams.arrivalAirportList && this.realparams.arrivalAirportList.length > 0) {
                for (let i = 0; i < this.realparams.arrivalAirportList.length; i++) {
                    this.filtersData.arrivalAirportList += '' + this.realparams.arrivalAirportList[i].code;
                    if (i < this.realparams.arrivalAirportList.length - 1) {
                        this.filtersData.arrivalAirportList += ',';
                    }
                }
            }
        }
    }

    protected initReisende(): void {
        if (this.realparams.reisendeResult) {
            this.filtersData.adults = '' + this.realparams.reisendeResult.adults;
            this.filtersData.children = '';
            if (this.realparams.reisendeResult && this.realparams.reisendeResult.children &&
                this.realparams.reisendeResult.children.length > 0) {
                for (let i = 0; i < this.realparams.reisendeResult.children.length; i++) {
                    this.filtersData.children += this.realparams.reisendeResult.children[i].age;
                    if (i < this.realparams.reisendeResult.children.length - 1) {
                        this.filtersData.children += ',';
                    }
                }
            }
        }
    }

    protected initSortby(): void {
        this.filtersData.sortBy = this.realparams.sortBy ? this.realparams.sortBy : 'price';
        this.filtersData.sortDir = this.realparams.sortDir ? this.realparams.sortDir : 'up';
    }

    protected initRating(): void {
        this.filtersData.rating = {
            source: 'holidaycheck',
            count: this.realparams.recommendationcount ? Number(this.realparams.recommendationcount) : 0,
            recommendation: this.realparams.recommendation ? Number(this.realparams.recommendation) : 0,
            // overall: this.realparams.recommendation ? Number(this.realparams.recommendation) : 0,
        };
    }

    protected checkTourOperatorList(): void {
        if (!this.filtersData?.tourOperatorList) {
            this.filtersData.tourOperatorList = '';
            for (let i = 0; i < this.agenturen?.length; i++) {
                if (this.agenturen[i]?.aktiv && this.agenturen[i]?.code !== 'HMR' && this.agenturen[i]?.code !== 'ERV') {
                    this.filtersData.tourOperatorList += this.agenturen[i]?.code + ',';
                }
            }
        }
    }

    protected checkTourOperatorListforStatic(): void {
        this.filtersData.tourOperatorList = '';
        for (let i = 0; i < this.agenturen?.length; i++) {
            if (this.agenturen[i]?.aktiv && this.agenturen[i]?.code !== 'HMR' && this.agenturen[i]?.code !== 'ERV') {
                this.filtersData.tourOperatorList += this.agenturen[i]?.code + ',';
            }
        }
    }

    protected initHotelChainList(): void {
        this.filtersData.hotelChainList = '';
        if (this.realparams.hotelChainList) {
            if (this.realparams.hotelChainList && this.realparams.hotelChainList.length > 0) {
                for (let i = 0; i < this.realparams.hotelChainList.length; i++) {
                    this.filtersData.hotelChainList += '' + this.realparams.hotelChainList[i].code;
                    if (i < this.realparams.hotelChainList.length - 1) {
                        this.filtersData.hotelChainList += ',';
                    }
                }
            }
        }
    }

    protected initRoomtype(): void {
        this.filtersData.roomTypeList = '';
        if (this.realparams.roomTypeList) {
            if (this.realparams.roomTypeList && this.realparams.roomTypeList.length > 0) {
                for (let i = 0; i < this.realparams.roomTypeList.length; i++) {
                    this.filtersData.roomTypeList += '' + this.realparams.roomTypeList[i].code;
                    if (i < this.realparams.roomTypeList.length - 1) {
                        this.filtersData.roomTypeList += ',';
                    }
                }
            }
        }
    }

    protected initRoomIdList(): void {
        // section room type
        this.filtersData.roomIdList = '';
        if (this.realparams.roomIdList) {
            if (this.realparams.roomIdList && this.realparams.roomIdList.length > 0) {
                for (let i = 0; i < this.realparams.roomIdList.length; i++) {
                    this.filtersData.roomIdList += '' + this.realparams.roomIdList[i].code;
                    if (i < this.realparams.roomIdList.length - 1) {
                        this.filtersData.roomIdList += ',';
                    }
                }
            }
        }
    }

    protected initServiceCodeList(): void {
        // section room type
        this.filtersData.serviceCode = '';
        if (this.realparams.serviceCode) {
            if (this.realparams.serviceCode && this.realparams.serviceCode.length > 0) {
                for (let i = 0; i < this.realparams.serviceCode.length; i++) {
                    this.filtersData.serviceCode += '' + this.realparams.serviceCode[i].code;
                    if (i < this.realparams.serviceCode.length - 1) {
                        this.filtersData.serviceCode += ',';
                    }
                }
            }
        }
    }

    protected initInclusiveList(): void {
        this.filtersData.inclusiveList = '';
        if (this.realparams.transferlist?.length > 0) {
            for (let i = 0; i < this.realparams.transferlist?.length; i++) {
                this.filtersData.inclusiveList += (this.filtersData.inclusiveList?.length > 0 ? ',' : '') +
                    (this.realparams.transferlist[i].code?.length > 0 ? this.realparams.transferlist[i].code : this.realparams.transferlist[i]);
            }
        }
        if (this.realparams.inclusiveList?.length > 0) {
            for (let i = 0; i < this.realparams.inclusiveList.length; i++) {
                this.filtersData.inclusiveList += (this.filtersData.inclusiveList?.length > 0 ? ',' : '') + this.realparams.inclusiveList[i].code;
            }
        }
    }

    protected setOperatorsAndInclists(): void {
        const opers = [];
        if (this.realparams.tourOperatorList && this.realparams.tourOperatorList.length > 0) {
            for (let i = 0; i < this.realparams.tourOperatorList.length; i++) {
                opers.push(this.realparams.tourOperatorList[i].code);
            }
        }

        // section inclusiveListServiceOffer
        if (this.realparams.inclusiveListServiceOffer?.length > 0) {
            let inerstct = []
            for (let i = 0; i < this.realparams.inclusiveListServiceOffer.length; i++) {
                if (inerstct?.length > 0) {
                    inerstct = inerstct.filter(x => this.realparams.inclusiveListServiceOffer[i].ops.includes(x));
                } else {
                    inerstct = [...this.realparams.inclusiveListServiceOffer[i].ops];
                }
            }
            if (opers?.length > 0) {
                inerstct = inerstct.filter(x => opers.includes(x));
            }
            if (inerstct?.length > 0) {
                this.filtersData.tourOperatorList = inerstct.join(',');
            }
        } else {
            this.filtersData.tourOperatorList = opers.join(',');
        }
    }

    protected initkeywordList(): void {
        this.filtersData.keywordList = '';
        if (this.realparams.keywordList?.length > 0) {
            for (let i = 0; i < this.realparams.keywordList.length; i++) {
                this.filtersData.keywordList += '' + this.realparams.keywordList[i].code;
                if (i < this.realparams.keywordList.length - 1) {
                    this.filtersData.keywordList += ',';
                }
            }
        }

        if (this.realparams.getrennteschlafzimmer) {
            this.filtersData.keywordList += this.filtersData.keywordList.length > 0 ? ',rbe' : 'rbe';
        }
    }

    protected initLocatedList(): void {
        this.filtersData.locatedList = '';
        if (this.realparams.zommermitmeerblick) {
            this.filtersData.locatedList = 'mb';
        }

        if (this.realparams.meerseite) {
            this.filtersData.locatedList = this.filtersData.locatedList?.length > 0 ? ',ms' : 'ms';
        }

        if (this.realparams.locatedList?.length > 0) {
            for (let i = 0; i < this.realparams.locatedList.length; i++) {
                if (this.filtersData.locatedList.indexOf(this.realparams.locatedList[i].code?.toLocaleLowerCase()) < 0) {
                    if (this.filtersData.locatedList?.length > 0) {
                        this.filtersData.locatedList += ',';
                    }
                    this.filtersData.locatedList += this.realparams.locatedList[i].code?.toLocaleLowerCase();
                }
            }
        }
    }

    protected initboardTypeList(): void {
        this.filtersData.boardTypeList = '';
        if (this.realparams.boardTypeList?.length > 0) {
            for (let i = 0; i < this.realparams.boardTypeList.length; i++) {
                this.filtersData.boardTypeList += '' + this.realparams.boardTypeList[i].code;
                if (i < this.realparams.boardTypeList.length - 1) {
                    this.filtersData.boardTypeList += ',';
                }
            }
        }
    }

    protected initPrice(): void {
        if (this.realparams.maxPricePerPerson) {
            this.filtersData.maxPricePerPerson = Number(this.realparams.maxPricePerPerson);
        } else {
            this.filtersData.maxPricePerPerson = null;
        }

        if (this.realparams.minPricePerPerson) {
            this.filtersData.minPricePerPerson = Number(this.realparams.minPricePerPerson);
        } else {
            this.filtersData.minPricePerPerson = null;
        }
    }

    protected initCategory(): void {
        if (Number(this.realparams.minCategory) >= 0) {
            this.filtersData.minCategory = Number(this.realparams.minCategory);
        } else {
            this.filtersData.minCategory = 0;
        }
    }

    protected initFlug(): void {
        this.filtersData.flight = {};
        this.filtersData.returnFlight = {};
        if (this.realparams.flightCarrierList) {
            this.filtersData.flight.carrierCodeList = '';
            if (this.realparams.flightCarrierList && this.realparams.flightCarrierList.length > 0) {
                for (let i = 0; i < this.realparams.flightCarrierList.length; i++) {
                    this.filtersData.flight.carrierCodeList += '' + this.realparams.flightCarrierList[i].code;
                    if (i < this.realparams.flightCarrierList.length - 1) {
                        this.filtersData.flight.carrierCodeList += ',';
                    }
                }
            }
        } else {
            this.filtersData.flight = {};
        }

        // direktflug
        this.filtersData.flight.travelClass = this.realparams?.flight?.travelClass;
        this.filtersData.flight.stopover = this.realparams?.flight?.stopover;
        this.filtersData.flight.directness = this.realparams?.flight?.directness;
        this.filtersData.flight.tariff = this.realparams?.flight?.tariff;
        this.filtersData.flight.bookingClass = this.realparams?.flight?.bookingClass;

        this.filtersData.returnFlight = this.filtersData.flight;
    }

    protected initTime() {
        this.filtersData.minReturnTime = '';
        this.filtersData.maxReturnTime = '';
        this.filtersData.minDepartureTime = '';
        this.filtersData.maxDepartureTime = '';
        if (this.realparams.maxreturnTime > 0 && this.realparams.maxreturnTime < 1440) {
            this.filtersData.maxReturnTime = this.transformMinute(this.realparams.maxreturnTime);
        }

        if (this.realparams.minreturnTime > 0 && this.realparams.minreturnTime < 1440) {
            this.filtersData.minReturnTime = this.transformMinute(this.realparams.minreturnTime);
        }

        if (this.realparams.maxdepartureTime > 0 && this.realparams.maxdepartureTime < 1440) {
            this.filtersData.maxDepartureTime = this.transformMinute(this.realparams.maxdepartureTime);
        }

        if (this.realparams.mindepartureTime > 0 && this.realparams.mindepartureTime < 1440) {
            this.filtersData.minDepartureTime = this.transformMinute(this.realparams.mindepartureTime);
        }
    }

    transformMinute(value: number): string {
        const hours = ('00' + Math.floor(value / 60)).slice(-2);
        const minutes = ('00' + Math.floor(value % 60)).slice(-2);
        return hours + ':' + minutes;
    }
}
